import { Model } from 'modules/core/lib/mobx-rest'

interface IPayrollResult {
  payroll_document_id: string
  document_id: string
}

class PayrollResult extends Model<IPayrollResult> {
  static urlRoot() {
    return '/bookkeepers_management/payroll_results'
  }
}

export default PayrollResult
